document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('ul.site-nav__dropdown').forEach(function(ul) {
    const listItems = ul.querySelectorAll('li');
    if (listItems.length > 10) {
      ul.classList.add('mega-menu-dropdown');
    }
  });
});